<div class="row" *ngIf="list?.length > 0">
    <div class="col-md-12 grid-margin stretch-card">
        <div class="card card-fit">
            <div class="card-header">
                <div class="row w-100">
                    <div class="col-12 d-flex justify-content-between align-items-start">
                        <h2 class="card-title">{{ title }}</h2>
                        <div class="input-group input-group-merge form-password-toggle w-50">
                            <input type="text" class="form-control" placeholder="Procurar por nome ou matrícula"
                                [(ngModel)]="filters.searchQuery" (input)="onSearchQueryChange()" />
                            <div *ngIf="filters.searchQuery" class="input-group-append" (click)="clearSearch()">
                                <span class="input-group-text cursor-pointer"><i class="feather icon-x"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <ng-container *ngIf="isLoading; else datatableBlock">
                    <div class="card card-fit card-table shadow mt-2">
                        <div class="card-body pt-2 text-center">
                            <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
                            <span>Carregando...</span>
                        </div>
                    </div>
                </ng-container>

                <ng-template #datatableBlock>
                    <div class="table-responsive">
                        <ngx-datatable [rows]="list" [count]="count" [limit]="queryParams.top"
                            [offset]="queryParams.skip / queryParams.top" (page)="onPage($event)"
                            (sort)="onSort($event)" class="ngx-datatable-custom" [rowHeight]="'auto'"
                            [columnMode]="'force'" [headerHeight]="56" [footerHeight]="56" [externalSorting]="true"
                            [sorts]="currentSort ? [currentSort] : []">
                            <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop"
                                [sortable]="col.sortable !== false" [width]="col.width">
                                <ng-template ngx-datatable-cell-template let-row="row">
                                    <ng-container [ngSwitch]="col.action">
                                        <ng-container *ngSwitchCase="'avatar'">
                                            <div class="d-flex align-items-center">
                                                <img alt="avatar"
                                                    [src]="row?.profileImagePath || '/assets/images/logo/avatar-profile.png'"
                                                    class="rounded-circle me-3" width="32" height="32" />
                                                <span>{{ row?.name || '—' }}</span>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'create'">
                                            <button title="Enviar Feedback"
                                                class="btn btn-sm p-0 d-flex align-items-center text-primary"
                                                (click)="handleCreateFeedback(row)">
                                                <i data-feather="send" class="me-1"></i>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            {{ row[col.prop] || '—' }}
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>

                    <div class="card-footer">
                        <app-paginator [count]="count" [queryParams]="queryParams" (query)="loadFeedbacks()"
                            type="squared" class="flex-1">
                        </app-paginator>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

</div>